import { LANGUAGES, type LangCode } from '@/lib/baba-api'
import { WsSelect } from './workspace'

interface Props {
  value: LangCode
  onChange: (code: LangCode) => void
  side: 'source' | 'target'
  disabledCode?: LangCode
  width?: number | string
  className?: string
}

/** Toolbar language select — `[English ▾]` / `[Hebrew ▾]`. No visible "From/To"
 * label (the mockup shows the bare language name); the side is still exposed
 * via aria-label for screen readers. */
export function TranslatorLangPicker({ value, onChange, side, disabledCode, width, className }: Props) {
  const lang = LANGUAGES.find((l) => l.code === value) ?? LANGUAGES[0]
  return (
    <WsSelect
      value={value}
      onChange={(v) => onChange(v as LangCode)}
      width={width}
      className={className}
      align={side === 'target' ? 'end' : 'start'}
      ariaLabel={`${side === 'source' ? 'Source' : 'Target'} language: ${lang.name}`}
      options={LANGUAGES.map((l) => ({
        id: l.code,
        label: l.name,
        sub: l.nativeName,
        disabled: l.code === disabledCode,
      }))}
    />
  )
}
